import * as React from "react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { ButtonToolbar, DeleteMenuItem, MenuItem } from "components/bootstrap";
import { ConfirmDialog, IfPermitted } from "components/common";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import MoreActions from "components/common/EntityDataTable/MoreActions";
import { useTableFetchContext } from "components/common/PaginatedEntityTable";
import UserNotification from "util/UserNotification";
import { hasCredentialsDefinition } from "data-tiering/repository-credentials";
import BlockingReferencesDialog from "./BlockingReferencesDialog";
import EditCredentialsModal from "./EditCredentialsModal";
import useDeleteRepository from "./hooks/useDeleteRepository";
const RepositoryActions = ({ repository }) => {
  const { t } = useTranslation("enterprise_data_tiering");
  const { deselectEntity } = useSelectedEntities();
  const { refetch } = useTableFetchContext();
  const { onDeleteRepository } = useDeleteRepository();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showEditCredentials, setShowEditCredentials] = useState(false);
  const [blockingReferences, setBlockingReferences] = useState(null);
  const supportsCredentials = hasCredentialsDefinition(repository.type);
  const handleDelete = () => {
    setShowDeleteDialog(false);
    onDeleteRepository(repository.name).then(() => {
      deselectEntity(repository.id);
      refetch();
    }).catch((error) => {
      var _a, _b;
      const body = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body;
      if ((error == null ? void 0 : error.status) === 400 && (body == null ? void 0 : body.blocking_references)) {
        setBlockingReferences(body.blocking_references);
      } else {
        UserNotification.error(
          t("repository_actions.delete_failed", { name: repository.name, message: (_b = body == null ? void 0 : body.message) != null ? _b : error }),
          t("repository_actions.could_not_delete")
        );
      }
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showDeleteDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showDeleteDialog,
      title: t("repository_actions.delete_title", { name: repository.name }),
      onCancel: () => setShowDeleteDialog(false),
      onConfirm: handleDelete
    },
    /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "repository_actions.delete_text",
        values: { name: repository.name },
        components: { strong: /* @__PURE__ */ React.createElement("strong", null) }
      }
    ))
  ), blockingReferences && /* @__PURE__ */ React.createElement(
    BlockingReferencesDialog,
    {
      repositoryName: repository.name,
      blockingReferences,
      onClose: () => setBlockingReferences(null)
    }
  ), showEditCredentials && /* @__PURE__ */ React.createElement(
    EditCredentialsModal,
    {
      repositoryName: repository.name,
      repositoryType: repository.type,
      onClose: () => setShowEditCredentials(false)
    }
  ), /* @__PURE__ */ React.createElement(
    IfPermitted,
    {
      permissions: supportsCredentials ? ["indexsets:edit", "indexsets:delete"] : ["indexsets:delete"],
      anyPermissions: true
    },
    /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(MoreActions, null, supportsCredentials && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "indexsets:edit" }, /* @__PURE__ */ React.createElement(MenuItem, { onSelect: () => setShowEditCredentials(true) }, t("repository_actions.edit_credentials"))), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "indexsets:delete" }, /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: () => setShowDeleteDialog(true) }))))
  ));
};
export default RepositoryActions;
